<label 
    for="{{forInput}}" 
    class="input-label {{additionalClasses}}"
    [ngClass]="{'error': !validationCSSClass, 'active': validationCSSClass }">
    <ng-content></ng-content>
</label>
